import type { TranslationKey } from "@/text/translations";

export const navigationLinks: { href: string; title: TranslationKey }[] = [
  { href: "/", title: "header.home" },
  { href: "/partners", title: "header.partners" },
  { href: "/integration-guide", title: "header.integrationGuide" },
];

export const legalLinks: {
  href: string;
  title: TranslationKey;
  target: "parent" | "_blank";
}[] = [
  {
    href: "https://www.propertyfinder.com/terms-and-conditions/#api-access-terms",
    title: "footer.termsConditions",
    target: "_blank",
  },
  {
    href: "https://www.propertyfinder.com/privacy-policy/",
    title: "footer.privacyPolicy",
    target: "_blank",
  },
  {
    href: "https://www.propertyfinder.com/cookie-policy/",
    title: "footer.cookiePolicy",
    target: "_blank",
  },
  { href: "/sitemap.xml", title: "footer.sitemap", target: "_blank" },
];
